import { Contact } from "../components/contact";
import siteData from "../data/data.json";
import { Seo } from "../components/Seo";
import { BreadcrumbLd } from "../components/BreadcrumbLd";
export default function Contacto() {
  const contactData = siteData["Contact"] || {};
  return (
    <>
      <Seo
        title="Contacto | Hípica Madrid Campogrande"
        description="Llámanos o escríbenos para información de clases, estabulación o eventos. También atendemos por WhatsApp."
        path="/contacto"
        image="https://madridcampogrande.es/og/default.jpg"
      />
      <BreadcrumbLd
        items={[
          { name: "Inicio", path: "/" },
          { name: "Contacto", path: "/contacto" },
        ]}
      />
      <Contact data={contactData} />
    </>
  );
}
